import * as calculatorConfig from '@/config/base-config.json';
import { SSD_INDUSTRIAL_LIST } from '../common';
import { generateSliderSteps } from '@/utils/generateSliderSteps';

export const CI_SALES_PROCEEDS_LABEL = {
  SalesType: 'Sales Type',
  Type: 'Type',
  Commercial: 'Commercial',
  Industrial: 'Industrial',
  SalesDetails: 'Sales Details',
  GST: 'GST',
  SellingPrice: 'Selling Price',
  OutstandingLoan: 'Outstanding Loan',
  OptionFee: 'Option Fee',
  OptionExerciseFee: 'Option Exercise Fee',
  PotentialExpenses: 'Potential Expenses',
  SSDLongForm: "Seller's Stamp Duty",
  LegalFee: 'Legal Fee',
  BanksPenaltyIfAny: "Bank's Penalty, If Any",
  BanksPenalty: "Bank's Penalty",
  ServiceCommission: 'Service Commission',
  Others: 'Others',
  CommercialPotentialExpensesNote: 'Commercial properties are exempt from SSD payment',
  Negative: 'Negative',
  SalesProceedsBreakdown: 'Sales Proceeds Breakdown',
  SalesProceed: 'Sales Proceeds',
  GSTBreakdown: 'GST Breakdown',
  BasedOnSellingPrice: 'Based on Selling Price',
  ReceivedWithOptionAndExerciseFee: 'Received with Option & Exercise Fee',
  OutstandingGSTReceivable: 'Outstanding GST Receivable',
  SalesProceedsTimeline: 'Sales Proceeds Timeline',
  OTP: 'OTP',
  OTPLongForm: 'Option to Purchase',
  ExercisePeriod: 'Exercise Period',
  CompletionPeriod: 'Completion Period',
  Weeks: 'Weeks',
  OtherExpenses: 'Other Expenses',
  ExerciseOfOTP: 'Exercise of OTP',
  SalesCompletion: 'Sales Completion',
  Balance: 'Balance',
  OptionExerciseFeeIncluded: 'Option Exercise Fee Included',
  PurchaseTimeline: 'Purchase Timeline',
  GenerateTimeline: 'Generate Timeline',
};

export const DEFAULT_BANK_PENALTY = calculatorConfig.bank_penalty_in_percent.default;

export enum SalesTypes {
  Commercial = 'Commercial',
  Industrial = 'Industrial',
}

export enum BreakdownColors {
  OUTSTANDING_LOAN = '#F25A73',
  CPF_USED_INTEREST = '#F692A3',
  POTENTIAL_EXPENSES = '#F8CB59',
  SALES_PROCEEDS = '#9475EB',
}

export enum GstStatus {
  YES = 'Yes',
  NO = 'No',
}

export enum BankPenaltyStatus {
  YES = 'Yes',
  NO = 'No',
}

export const OPTION_FEE = {
  DEFAULT: calculatorConfig.option_fee_in_percent.default,
  RANGE: generateSliderSteps(0, calculatorConfig.option_fee_in_percent.max),
  MIN: calculatorConfig.option_fee_in_percent.min,
};

export const OPTION_EXERCISE_FEE = {
  DEFAULT: calculatorConfig.option_exercise_fee_in_percent.default,
  RANGE: generateSliderSteps(0, calculatorConfig.option_exercise_fee_in_percent.max),
  MIN: calculatorConfig.option_exercise_fee_in_percent.min,
};

export const BANK_PENALTY = {
  DEFAULT: 0,
  MAX: calculatorConfig.bank_penalty_in_percent.max,
  STEP: 0.5,
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.bank_penalty_in_percent.min,
    calculatorConfig.bank_penalty_in_percent.max,
    0.5,
  ),
};

export const INDUSTRIAL_SSD = {
  DEFAULT: '0',
  LIST: SSD_INDUSTRIAL_LIST.map((value) => {
    return {
      value: value.toString(),
      label: `${value}%`,
    };
  }),
};

export const EXERCISE_PERIOD = {
  DEFAULT: calculatorConfig.exercise_period_in_weeks.default,
  MIN: calculatorConfig.exercise_period_in_weeks.min,
  MAX: calculatorConfig.exercise_period_in_weeks.max,
  STEP: 1,
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.exercise_period_in_weeks.min,
    calculatorConfig.exercise_period_in_weeks.max,
  ),
};

export const COMPLETION_PERIOD = {
  DEFAULT: calculatorConfig.completion_period_in_weeks.default,
  MIN: calculatorConfig.completion_period_in_weeks.min,
  MAX: calculatorConfig.completion_period_in_weeks.max,
  STEP: 1,
  LABEL_INPUTS: generateSliderSteps(
    calculatorConfig.completion_period_in_weeks.min,
    calculatorConfig.completion_period_in_weeks.max,
  ),
};
